import { ClientBrandingConfig } from '../../types/clientConfig';
import { CLIENTS } from '../types';
import { configIcons } from '@/assets/icons';
import { revolutionColorOverrides } from '@/themes/custom/colorPalettes/revolution';
/**
 * Revolutions Client Configuration
 */
const revolutionsConfig: ClientBrandingConfig = {
  clientId: CLIENTS.REVOLUTION,
  clientName: 'Revolutions',
  logoSrc: configIcons.revolutionLogo,
  logoAlt: 'Revolutions Logo',
  faviconSrc: configIcons.revolutionProfileLogo,
  colorPaletteSrc: revolutionColorOverrides,
  headerBgColor: '#1e3a8a',
  headerTextColor: '#ffffff',
  footerBgColor: '#f8fafc',
  footerTextColor: '#64748b',
  footerCopyright:
    '© 2025 Revolutions Financial Services. All rights reserved.',
  minAge: 18,
  maxAge: 99,
};
export default revolutionsConfig;
